import SV_SE from './sv-SE.json';
import DA_DK from './da-DK.json';
import EN_DK from './en-DK.json';
import EN_SE from './en-SE.json';
import EN_FI from './en-FI.json';
import EN_BE from './en-BE.json';
import EN_NL from './en-NL.json';
import NL_NL from './nl-NL.json';
import NL_BE from './nl-BE.json';
import PL_NL from './nl-PL.json';
import FI_FI from './fi-FI.json';
import NO_NO from './no-NO.json';
import EN_NO from './en-NO.json';
import FR_BE from './fr-BE.json';
import FR_NL from './fr-NL.json';

interface ITranslation {
  components: any;
  error: any;
}

export interface ICombinedTranslations {
  'sv-SE': ITranslation;
  'en-SE': ITranslation;
  'da-DK': ITranslation;
  'en-DK': ITranslation;
  'en-FI': ITranslation;
  'fi-FI': ITranslation;
  'nl-NL': ITranslation;
  'en-NL': ITranslation;
  'en-BE': ITranslation;
  'nl-BE': ITranslation;
  'no-NO': ITranslation;
  'en-NO': ITranslation;
  'fr-BE': ITranslation;
  'fr-NL': ITranslation;
  'pl-NL': ITranslation;
}

const combinedTranslations: ICombinedTranslations = {
  'sv-SE': SV_SE,
  'en-SE': EN_SE,
  'da-DK': DA_DK,
  'en-DK': EN_DK,
  'en-FI': EN_FI,
  'fi-FI': FI_FI,
  'nl-NL': NL_NL,
  'en-NL': EN_NL,
  'en-BE': EN_BE,
  'nl-BE': NL_BE,
  'no-NO': NO_NO,
  'en-NO': EN_NO,
  'fr-BE': FR_BE,
  'fr-NL': FR_NL,
  'pl-NL': PL_NL,
};

export default combinedTranslations;
